import styled from "styled-components";

export const StyledWrapper = styled.div`
  position: absolute;
  top: 32px;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StyledIcon = styled.span`
  margin-bottom: 10px;
  display: flex;
`;
